import { useAirline } from "../context/AirlineContext";
import { ServicesClusters } from "../shared/AirlineSlideRenderers";

const SlideSQServices = () => {
  const { airline } = useAirline();
  const brand = airline.brandColor || "#F2A900";
  return <ServicesClusters airline={airline} brand={brand} />;
};

export default SlideSQServices;
